// @ts-check

import HttpClient from '@/utils/clients/clientBookMain';
import ServiceError from '@/utils/errors/ServiceError';
import { buildErrorCollection } from '@/utils/formatters/processingOpenApi';
import { ERROR_SERVER_ERROR } from '@/utils/constants/globalConst';

export default class CashbackService {
  constructor(config) {
    this.mainHttp = new HttpClient(config);
  }

  /**
   * @typedef {Object} CashbackByBasketRes
   * @property {number} mnogoruBonusesForOrder - Сколько баллов много.ру будет начислено за заказ
   * @property {number} plBonusesForOrder - Сколько кешбека будет начислено за заказ
   */

  /**
   * Возвращает информацию о начислении баллов программы лояльности за заказ
   * @param {Object} payload
   * @param {('preorder' | 'basket')} payload.basketMode - Режим корзины, обычный или для предзаказа
   * @param {('Y' | 'N')} payload.useBonusPay - Признак установки частичной оплаты баллами
   * @param {(1 | 2)} payload.personTypeId - Тип плательщика. 1 - физическое лицо, 2 - юридическое лицо
   * @param {number} payload.paySystemId - Идентификатор платёжной системы
   * @param {number} payload.deliveryId - Идентификатор службы доставки
   * @param {string} payload.location - Идентификатор местоположения
   * @param {string} [payload.pvzCode] - Код ПВЗ
   * @param {string} [payload.certificate] - Код сертификата
   * @param {string} [payload.addressFull] - Полный адрес доставки
   * @param {string} [payload.zip] - Индекс доставки
   * @param {string} payload.recommendationProduct - Список рекомендованных товаров, идентификаторы товаров через запятую
   * @return {Promise<CashbackByBasketRes>}
   */
  getCashbackByBasket(payload) {
    return new Promise((resolve, reject) => {
      this.mainHttp.get('/api/v1/sale/basket/personal/', payload)
        .then(({ data: { data } }) => resolve({
          mnogoruBonusesForOrder: data.mnogoruBonusesForOrder,
          plBonusesForOrder: data.plBonusesForOrder,
        }))
        .catch((e) => {
          if (e.response) {
            if (e.response.status === 500) {
              reject(new ServiceError(ERROR_SERVER_ERROR));
            }
            const errors = buildErrorCollection(e.response.data);
            const [firstError] = errors;
            reject(new ServiceError(firstError));
          }
          reject(new ServiceError(e));
        });
    });
  }
}
